<template>
    <v-container class="pa-6 pa-lg-12 fill-height align-start" fluid>
        <v-row>
            <v-col cols="12" md="6" class="d-flex justify-space-between align-center py-0">
                <span class="headline mr-4">Languages</span>
            </v-col>
        </v-row>
        <v-row >
            <v-col cols="12" md="6" class="d-flex align-center py-4">
                <v-card width="100%" flat color="grey lighten-4">
                    <v-row class="px-4" align="center">
                        <v-col cols="6">
                            <v-text-field
                                dense
                                outlined
                                hide-details
                                label="Language"
                                v-model="languageName"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                dense
                                outlined
                                hide-details
                                label="Iso"
                                v-model="languageIso"
                            ></v-text-field>                            
                        </v-col>
                        <v-col cols="2" class="text-right">
                            <v-btn
                                small
                                depressed
                                height="40px"
                                width="100%"
                                color="primary"
                                :disabled="!isLanguageFormValid || creating"
                                :loading="creating"
                                @click="creatLanguage"
                            >Save</v-btn>
                        </v-col>                            
                    </v-row>
                </v-card>                    
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6" class="py-0">
                <template v-if="!loading">
                    <template v-if="languages.length > 0">
                        <v-card outlined width="100%" class="mt-4">
                            <v-row class="px-4">
                                <v-col cols="5" class="flex-grow-1 flex-shrink-0 py-1"><span class="overline">Label</span></v-col>
                                <v-col cols="3" class="flex-grow-1 flex-shrink-0 py-1"><span class="overline">ISO</span></v-col>
                                <v-col cols="2" class="flex-grow-1 flex-shrink-0 py-1 text-center"><span class="overline">Is default</span></v-col>
                                <v-col cols="2" class="flex-grow-0 flex-shrink-0 text-center py-1"><span class="overline">Actions</span></v-col>
                            </v-row>
                            <template v-for="(language, index) in languages">
                                <v-divider :key="`B${index}`"></v-divider>
                                <v-row 
                                    align="center"
                                    class="px-4 py-1"
                                    :key="`A${index}`"
                                >
                                    <v-col cols="5" class="flex-grow-1 flex-shrink-0 py-1">
                                        <span class="subtitle-2" v-text="language.label"></span>
                                    </v-col>
                                    <v-col cols="3" class="flex-grow-1 flex-shrink-0 py-1">
                                        <span class="subtitle-2" v-text="language.iso639"></span>
                                    </v-col>
                                    <v-col cols="2" class="flex-grow-1 flex-shrink-0 py-1 text-center">
                                        <input 
                                            type="radio" 
                                            name="default-language" 
                                            :checked="language.isDefault"
                                            @change="changeDefaultLanguage(index, language.id)"
                                        />
                                    </v-col>
                                    <v-col cols="2" class="flex-grow-0 flex-shrink-0 text-center py-1">
                                        <v-btn 
                                            icon
                                            color="primary" 
                                            class="mr-2"
                                            @click="updateLanguageEventHandler(language)"
                                        ><v-icon>mdi-pencil</v-icon></v-btn>
                                          <v-btn 
                                            icon
                                            color="primary" 
                                            class="mr-2"
                                            @click="deleteLanguageEventHandler(language)"
                                        ><v-icon>mdi-delete</v-icon></v-btn>
                                    </v-col>
                                </v-row>
                            </template>
                        </v-card>
                    </template>
                    <template v-else>
                        <v-card outlined class="mt-4">
                            <v-card-subtitle>No languages available</v-card-subtitle>
                        </v-card>
                    </template>
                </template>
                <template v-else>
                    <v-progress-circular
                        :size="35"
                        color="primary"
                        class="mt-6"
                        indeterminate
                    ></v-progress-circular>
                </template>
            </v-col>
        </v-row>
        <!-- Update level label sheet -->
        <v-bottom-sheet v-model="updateLangugeSheet">
            <v-sheet class="text-center">                
                <v-row no-gutters justify="center" class="py-6">
                    <v-col cols="12" md="6" lg="4">
                        <v-row>
                            <v-col cols="8">
                                <v-text-field
                                    dense
                                    outlined
                                    hide-details
                                    label="Language"
                                    v-model="selectedLanguage.label"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field
                                    dense
                                    outlined
                                    hide-details
                                    label="Iso"
                                    v-model="selectedLanguage.iso639"
                                ></v-text-field>                            
                            </v-col>
                        </v-row>
                        <div class="d-flex">
                            <v-btn
                                small
                                depressed
                                color="primary"
                                @click="updateLanguage"
                            >Save</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                small
                                color="secondary"
                                @click="updateLangugeSheet = false"
                            >Close</v-btn>
                        </div>
                    </v-col>
                </v-row>              
            </v-sheet>
        </v-bottom-sheet>

          <!-- Delete level label sheet -->
        <v-bottom-sheet v-model="deleteLanguageSheet">
            <v-sheet class="text-center">                
                <v-row no-gutters justify="center" class="py-6">
                    <v-col cols="12" md="6" lg="4">
                        <v-row>
                            <v-col cols="12">
                                <span>Are you sure you want to delete {{selectedLanguage.label}} language?</span>
                            </v-col>
                        </v-row>
                        <div class="d-flex justify-center">
                            <v-btn
                                small
                                depressed
                                color="primary"
                                @click="deleteLanguage"
                            >Yes</v-btn>
                            <v-btn
                                text
                                small
                                color="secondary"
                                @click="deleteLanguageSheet = false"
                            >No</v-btn>
                        </div>
                    </v-col>
                </v-row>              
            </v-sheet>
        </v-bottom-sheet>

    </v-container>
</template>

<script>
    export default {
        name: 'languages',
        data: () => ({
            languages: [],
            languageName: '',
            languageIso: '',
            selectedLanguage: {},
            snackbar: {
                show: true,
                message: ''
            },
            updateLangugeSheet: false,
            deleteLanguageSheet: false,
            creating: false,
            updating: false,
            deleting: false,
            loading: true
        }),
        computed: {
            isLanguageFormValid() {
                if(this.languageName && this.languageIso) {
                    return true
                } 
                return false
            }
        },
        mounted() {
            this.fetchLanguages()
        },
        methods: {
            async fetchLanguages() {
                this.axios.get('/Language/GetAll', {
                    params: {
                        languageId: 1
                    }
                })
                .then(response => {
                    this.languages = response.data.list
                })
                .catch(error => {
                    this.snackbar.message = error.response.data
                    this.$EventBus.$emit('snackbar', this.snackbar)
                })
                this.loading = false
            },
            creatLanguage() {
                this.creating = true
                const data = {
                    iso639: this.languageIso,
                    label: this.languageName,
                    languageId: 1,
                    description: this.languageName
                }
                this.axios.post('/Language/CreateLanguage', data)
                .then(response => {
                    this.languages.push(response.data)
                    this.snackbar.message = 'Language created successfully'
                    this.$EventBus.$emit('snackbar', this.snackbar)
                    this.languageName = ''
                    this.languageIso = ''
                    this.creating = false
                })
                .catch(error => {
                    this.snackbar.message = error.response.data
                    this.$EventBus.$emit('snackbar', this.snackbar)
                    this.creating = false
                })
            },
            updateLanguageEventHandler(language) {
                this.selectedLanguage.id = language.id
                this.selectedLanguage.iso639 = language.iso639
                this.selectedLanguage.label = language.label
                this.selectedLanguage.languageId = language.languageId
                this.selectedLanguage.description = language.description
                this.selectedLanguage.isDefault = language.isDefault
                this.updateLangugeSheet = true
            },
            updateLanguage() {
                this.updating = true
                const data = {
                    id: this.selectedLanguage.id,
                    iso639: this.selectedLanguage.iso639,
                    label: this.selectedLanguage.label,
                    languageId: this.selectedLanguage.languageId,
                    description: this.selectedLanguage.label,
                    isDefault: this.selectedLanguage.isDefault
                }
                this.axios.post('/Language/UpdateLanguage', data)
                .then(response => {
                    let index = this.languages.map(lang => {
                        return lang.id
                    }).indexOf(this.selectedLanguage.id)
                    this.languages[index] = response.data
                    
                    this.snackbar.message = 'Language updated successfully'
                    this.$EventBus.$emit('snackbar', this.snackbar)

                    this.updating = false
                    this.updateLangugeSheet = false
                    this.selectedLanguage = {}
                })
                .catch(error => {
                    this.snackbar.message = error.response.data
                    this.$EventBus.$emit('snackbar', this.snackbar)
                    this.updating = false
                })
            },
            changeDefaultLanguage(index, id) {
                this.axios.post(`Language/SetDefaultLanguage?languageId=${id}`)
                .then(response => {
                    const language = {
                        description: this.languages[index].description,
                        id: id,
                        isDefault: true,
                        iso639: this.languages[index].iso639,
                        label: this.languages[index].label,
                        languageId: id,
                        parentId: this.languages[index].parentId
                    }
                    this.$store.dispatch('setDefaultLanguage', id)
                    .then(() => {
                        this.snackbar.message = 'System default language has changed'
                        this.$EventBus.$emit('snackbar', this.snackbar)
                    })
                })
                .catch(error => {
                    this.snackbar.message = error.message
                    this.$EventBus.$emit('snackbar', this.snackbar)
                })
            },
            deleteLanguageEventHandler(language){
                this.selectedLanguage.id = language.id
                this.selectedLanguage.iso639 = language.iso639
                this.selectedLanguage.label = language.label
                this.selectedLanguage.languageId = language.languageId
                this.selectedLanguage.description = language.description
                this.selectedLanguage.isDefault = language.isDefault
                this.deleteLanguageSheet = true
            },
            deleteLanguage(){
                this.deleting = true;
                this.axios.delete(`/Language/DeleteLanguage?id=${this.selectedLanguage.id}&languageId=${this.selectedLanguage.languageId}`)
                .then(res => {
                    this.snackbar.message = 'Language successfuly deleted'
                    this.$EventBus.$emit('snackbar', this.snackbar)
                    
                    this.deleting = false;
                    this.deleteLanguageSheet = false;
                    this.languages = this.languages.filter(c => c.id !== this.selectedLanguage.id);
                    this.selectedLanguage = {}
                })
                .catch(err => {
                    this.deleting = false;
                    this.deleteLanguageSheet = false;
                    if(err.response.status === 400){
                        this.snackbar.message = err.response.data
                        this.$EventBus.$emit('snackbar', this.snackbar)
                    }else{
                        this.snackbar.message = err.message
                        this.$EventBus.$emit('snackbar', this.snackbar)
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>